/**
 * @fileoverview Utility class for managing permissions
 *
 * @example
 * // Usage:
 * import { PermissionManager } from './PermissionManager'
 *
 * function Component() {
 *   // ...
 * }
 */

import { MediaDevice } from './MediaDevice'

/**
 * @class PermissionManager
 * @description Utility class for managing permissions
 */
export class PermissionManager {
    /**
     * Request media device permissions.
     * Currently, permissions are requested for audio recording only. Passed arguments are ignored.
     * @returns Promise<boolean>
     */
    static async request(_permissions: string[]): Promise<boolean> {
        const mediaDevice = new MediaDevice()
        if (!mediaDevice.isSupportingAudioRecording()) {
            return
        }

        try {
            const stream = await mediaDevice.getStream()

            stream.getTracks().forEach((track) => {
                if (track.readyState == 'live') {
                    track.stop()
                }
            })

            return true
        } catch (e) {
            return false
        }
    }
}
